import { Controller } from "@hotwired/stimulus"

// Калькулятор стоимости на странице тарифов. Ставки приходят из Pricing::TIERS
// через data-price-calculator-tiers-value, ставка применяется ко всем магазинам.
export default class extends Controller {
  static targets = ["input", "rate", "total", "result", "individual"]
  static values = { tiers: Array, max: Number }

  connect() {
    this.calculate()
  }

  calculate() {
    const count = parseInt(this.inputTarget.value, 10) || 0
    const individual = count > this.maxValue
    const tier = this.tiersValue.find((t) => count >= t.min && count <= t.max)

    this.resultTarget.hidden = individual
    this.individualTarget.hidden = !individual
    if (individual) return

    const rate = tier ? tier.rate : 0
    this.rateTarget.textContent = this.format(rate)
    this.totalTarget.textContent = this.format(rate * count)
  }

  // Переносит количество магазинов в форму заявки внизу страницы
  apply() {
    const field = document.querySelector('#lead-form [name="lead[shops_count]"]')
    if (field) field.value = this.inputTarget.value
  }

  format(amount) {
    return `${new Intl.NumberFormat("ru-RU").format(amount)} ₽`
  }
}
